// Opens a stored agreement file (a register document or a signed addendum) in
// a new tab, for the Agreements page and the driver's agreements panel.
import { useGetAgreementFileUrl } from './backend/agreements'

function message(e: unknown): string {
  return e instanceof Error ? e.message : String(e)
}

// Opens a stored file in a new tab. The tab is opened before the request so a
// popup blocker sees a click, then pointed at the signed link.
export function useOpenAgreementFile() {
  const fileUrl = useGetAgreementFileUrl<{ url: string }>()
  return async (ids: { document_id?: string; addendum_id?: string }) => {
    const w = window.open('', '_blank')
    try {
      const r = await fileUrl.trigger(ids, { skipCache: true })
      if (w && r?.url) w.location.href = r.url
    } catch (e) {
      w?.close()
      window.alert(message(e))
    }
  }
}
